// @flow
import 'isomorphic-fetch';
import React from 'react';
import injectSheet from 'react-jss';
import Slot from 'shared/editor/Slot';
import PostCard from 'shared/components/PostCard';
import type { $Slot } from '../../../types';
import { getAPIDomain } from 'shared/lib/clientSettings';
import withThemeProvider from 'shared/hoc/withThemeProvider';
import {
  FONT_FAMILY_ROBOTO
} from 'shared/constants';

type TemplateSettings = {
  region: string,
  page_title: string,
  tag: string,
  section: string
}

type Props = {
  classes: Object,
  slots: $Slot[],
  templateSettings: TemplateSettings,
  widgetPresets: Array,
  path: string
}

class FutureSightTag extends React.Component {
  props: Props = this.props;

  state = {
    posts: []
  }

  componentDidMount = () => {
    const { templateSettings } = this.props;
    const tag = templateSettings.tag.toLowerCase();

    let dest;

    if (templateSettings.section === 'FUTURESIGHT') {
      dest = 'futuresight';
    } else if (templateSettings.section === 'PRESSROOM') {
      dest = 'press-room';
    }
    const fetchDomain = getAPIDomain(templateSettings.region) || '';

    // Fetch data for featured posts
    fetch(`${fetchDomain}/api/${dest}/postlist?region=${templateSettings.region}&tag=${tag}`)
      .then(res => res.json())
      .then((res) => {
        this.setState({
          posts: res.pages
        });
      })
      .catch(() => {
      });
  }

  render() {
    const {
      classes: c, slots, templateSettings, widgetPresets, path
    } = this.props;
    const { posts } = this.state;
    const postGrid = posts.length > 0 && (
      posts.map((post, i) => (
        <PostCard post={post.template.props} key={i} />
      ))
    );
    const pageTitle = (
      <div className={c.title}>
        <span>{templateSettings.page_title}: </span>
        <span>{templateSettings.tag}</span>
      </div>
    );

    return (
      <div className={c.container}>
        <div className={c.menu}>
          <Slot id="menu-bar" slots={slots} widgetPresets={widgetPresets} path={path} />
        </div>
        {pageTitle}
        <div className={c.posts}>
          {postGrid}
        </div>
        <footer id="footer" className={c.footer}>
          <Slot id="footer" slots={slots} widgetPresets={widgetPresets} path={path} />
        </footer>
      </div>
    );
  }
}

const styles = {
  container: {
    width: '100%',
    background: '#f7f7f7'
  },
  menu: {
    width: '100%',
    position: 'relative',
    zIndex: '10'
  },
  footer: {
    width: '100%'
  },
  posts: {
    padding: '49px 36px',
    display: 'flex',
    flexWrap: 'wrap'
  },
  title: {
    width: '100%',
    fontFamily: FONT_FAMILY_ROBOTO,
    fontSize: '40px',
    fontWeight: '300',
    letterSpacing: '1px',
    lineHeight: '1.2',
    padding: '156px 36px 72px',
    backgroundColor: 'white'
  }
};

export default withThemeProvider(injectSheet(styles)(FutureSightTag));
